import { z } from 'zod';

export const schemaEuropaceProcessEvent = z.object({
    date: z.coerce.date().nullish(),
    documents: z
        .array(
            z.object({
                displayName: z.string().nullish(),
                documentId: z.string().nullish(),
                uri: z.string().nullish(),
            }),
        )
        .nullish(),
    text: z.string().nullish(),
    // could also be an ENUM, but we do not have enough information to define it
    type: z.string().nullish(),
});

export type SchemaEuropaceProcessEvent = z.infer<typeof schemaEuropaceProcessEvent>;
